import React, { useContext } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
import { useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
// Mui components
import { Box, Button, Modal, Typography, Backdrop, Fade } from '@mui/material';
// Components
import HorizontalDivider from '../../common/HorizontalDivider';
import DotLoader from '../../common/Loaders/DotLoader/DotLoader.jsx';
// Icons
import IconBuilding from '../../../utils/images/icon_building.svg';
import IconCircleCheck from '../../../assets/icons/icon_circle-check.svg';
// Hooks
import { toCamelCaseFirstWord } from '../../../utils/Hooks/textFormatted';

export default function ModalEnviarSolicitudModificacion({
  isLoading,
  especialidadesDefault,
  selectedEspecializaciones,
  modalIsVisible,
  handleClose,
  handleClick,
  succesSolicitud,
  openModalError
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { consultorioDetail } = useContext(AgendaContext);

  const direccionOsdeArray = consultorioDetail?.consultorioOsde[0]?.direccion.split(',');
  const direccionOsdeFormateada = [...new Set(direccionOsdeArray)].join(', ');

  function obtenerModificaciones(especialidadesDefault, selectedEspecializaciones) {
    const especialidadesBaja = [];
    const especialidadesAlta = [];

    especialidadesDefault.forEach((especialidadDefault) => {
      const especialidadSeleccionada = selectedEspecializaciones.find(
        (especialidad) => especialidad.codigoOsde === especialidadDefault.codigoOsde
      );

      if (especialidadDefault.solicitada && !especialidadSeleccionada?.solicitada) {
        especialidadesBaja.push(especialidadDefault);
      } else if (!especialidadDefault.solicitada && especialidadSeleccionada?.solicitada) {
        especialidadesAlta.push(especialidadSeleccionada);
      }
    });

    return { especialidadesBaja, especialidadesAlta };
  }

  const { especialidadesBaja, especialidadesAlta } = obtenerModificaciones(
    especialidadesDefault,
    selectedEspecializaciones
  );

  const handleSuccesSolicitud = () => {
    navigate('/prestador/dashboard');
    handleClose();
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={modalIsVisible}
      onClose={modalIsVisible}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}>
      <Fade in={modalIsVisible}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: 452, sm: 452 },
            height: 'fit-content',
            bgcolor: 'white.main',
            borderRadius: '10px',
            p: 5
          }}>
          {!succesSolicitud && !openModalError && (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Typography
                  id="detalles"
                  variant="h2"
                  sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                  ¿Querés enviar las modificaciones realizadas?
                </Typography>

                <Box
                  sx={{
                    backgroundColor: theme.palette.backgroundPrimary.main,
                    height: '76px',
                    width: '100%',
                    padding: '1rem',
                    flexDirection: 'row',
                    borderRadius: '1rem',
                    display: 'flex',
                    gap: '0.5rem'
                  }}>
                  <Box
                    component="img"
                    sx={{ width: '16px', height: '16px' }}
                    alt="img not found"
                    src={IconBuilding}
                  />
                  <Typography variant="h5" color={theme.palette.black.main}>
                    {direccionOsdeFormateada}
                  </Typography>
                </Box>
                {especialidadesAlta.length > 0 && (
                  <>
                    <Typography variant="tabs">Conexión de agendas para:</Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        height: 'auto',
                        border: `2px solid ${theme.palette.backgroundSecondary.main}`,
                        borderRadius: '1rem',
                        gap: '1rem',
                        padding: '1rem',
                        flexDirection: 'column'
                      }}>
                      {especialidadesAlta &&
                        especialidadesAlta.map((especialidad, index) => {
                          return (
                            <Typography key={index}>
                              {toCamelCaseFirstWord(especialidad.descripcion)}
                            </Typography>
                          );
                        })}
                    </Box>
                  </>
                )}

                {especialidadesAlta.length > 0 && especialidadesBaja.length > 0 && (
                  <Box sx={{ height: '1rem', marginTop: '1rem' }}>
                    <HorizontalDivider />
                  </Box>
                )}
                {especialidadesBaja.length > 0 && (
                  <>
                    <Typography variant="tabs">Desconexión de agendas para:</Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        height: 'auto',
                        border: `2px solid ${theme.palette.backgroundSecondary.main}`,
                        borderRadius: '1rem',
                        gap: '1rem',
                        padding: '1rem',
                        flexDirection: 'column'
                      }}>
                      {especialidadesBaja &&
                        especialidadesBaja.map((especialidad, index) => {
                          return (
                            <Typography key={index}>
                              {toCamelCaseFirstWord(especialidad.descripcion)}
                            </Typography>
                          );
                        })}
                    </Box>
                  </>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  marginTop: '34px',
                  justifyContent: 'space-around'
                }}>
                <Button
                  variant="outlined"
                  disabled={isLoading}
                  onClick={handleClose}
                  sx={{
                    width: '176px',
                    height: '3rem',
                    borderRadius: '1rem',
                    '&.Mui-disabled': {
                      borderColor: theme.palette.gray.main
                    }
                  }}>
                  Mejor no
                </Button>

                <Box sx={{ position: 'relative' }}>
                  <Button
                    sx={{
                      width: '176px',
                      height: '3rem',
                      borderRadius: '1rem',
                      '&.Mui-disabled': {
                        backgroundColor: isLoading
                          ? theme.palette.darkBlue.main
                          : theme.palette.primary.main,
                        color: '#FFFFFF'
                      }
                    }}
                    disabled={isLoading}
                    variant="contained"
                    onClick={handleClick}
                    color="primary">
                    Enviar
                    {isLoading && (
                      <Box sx={{ position: 'absolute', right: '1rem' }}>
                        <DotLoader size="7px" />
                      </Box>
                    )}
                  </Button>
                </Box>
              </Box>
            </>
          )}
          {succesSolicitud && !openModalError && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: 452, sm: 452 },
                maxHeight: '386px',
                bgcolor: 'white.main',
                borderRadius: '16px',
                p: 5
              }}>
              <Box
                component="img"
                sx={{ width: '53.33px', height: '53.33px', cursor: 'pointer' }}
                alt="img not found"
                src={IconCircleCheck}
              />
              <Typography
                id="detalles"
                variant="h1"
                sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1rem' }}>
                Modificación solicitada
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  marginTop: '1rem',
                  gap: '1rem'
                }}>
                <Typography variant="h4">Será analizada por nuestro equipo.</Typography>
                <Typography variant="h5">
                  Podés realizar el seguimiento de su estado desde la página de inicio.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  marginTop: '28px',
                  justifyContent: 'center'
                }}>
                <Button
                  sx={{ width: '372px', height: '3rem', borderRadius: '1rem' }}
                  variant="contained"
                  onClick={handleSuccesSolicitud}
                  color="primary">
                  Entendido
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
